/**
* Total slide time needs to be adjusted with delta -1 second,
* because player-core stops playing slide right 1 second before actual end
* */
export const adjustedCurrentSlideTotalTime = ({currentSlideIndex, slidesDurations}) => {
  const numberOfSlides = slidesDurations.length
  const totalSlideDuration = slidesDurations[currentSlideIndex]
  const timeDelta = (currentSlideIndex + 1 === numberOfSlides) ? 0 : 1
  return totalSlideDuration - timeDelta
}